/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

import {connect} from 'react-redux';
import classNames from 'classnames';

import _ from 'topmeteo/utils/i18n';

import {deleteLocation} from 'topmeteo/loc/actionCreators';

const DeleteLocationTitle = _('Delete Location');
const DeleteSelectedTitle = _('The currently selected location cannot be deleted.');

const LocationManagerDeleteButton = ({isSelected, onDelete}) => (
    <strong
        className={classNames('control icon-trash-empty', {disabled: isSelected})}
        title={isSelected ? DeleteSelectedTitle : DeleteLocationTitle}
        onClick={isSelected ? null : onDelete}
    />
);

const mapStateToProps = ({locationID}, {location}) => ({
    isSelected: locationID === location,
});

const mapDispatchToProps = (dispatch, {location}) => ({
    onDelete: () => dispatch(deleteLocation(location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationManagerDeleteButton);
